import { useEffect, useState } from 'react';

import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../../config';
import { useNavigate } from 'react-router-dom';

const Protected = ({ children }) => {
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            setLoading(false);
            if (!user) {

                navigate("/login")
            }
        });

        return () => unsubscribe();
    }, []);
    if (loading) {
        return <div>Loading...</div>;
    }
    return auth.currentUser ? <>{children}</> : null;
};

export default Protected;